import { createRouter, createWebHistory } from 'vue-router'

const HomeView = () => import('@/views/HomeView.vue')
const LoginView = () => import('@/views/loginView.vue')
const TestView = () => import('@/views/test/TestView.vue')
const EvaluationHubView = () => import('@/views/batch/EvaluationHubView.vue')
const InstructionView = () => import('@/views/test/InstructionView.vue')
const AcrInstructionView = () => import('@/views/test/AcrInstructionView.vue')
const AcrView = () => import('@/views/test/AcrView.vue')
const DisplayPrecheck = () => import('@/views/DisplayPrecheck.vue')

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/login', name: 'login', component: LoginView},
  { path: '/test', name: 'test', component: TestView },
  { path: '/evaluation-hub', alias: '/batch-selection', name: 'evaluation-hub', component: EvaluationHubView },
  { path: '/instruction', name: 'instruction', component: InstructionView},
  { path: '/acr-instruction', name: 'acr-instruction', component: AcrInstructionView},
  { path: '/acr',  name: 'AcrView',  component: AcrView},
  { path: '/display-precheck', name: 'display-precheck', component: DisplayPrecheck }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'display-precheck') {
    next();
    return;
  }

  if (!localStorage.getItem('subject')) {
    next('/login');
    return;
  }

  const canEnterPrecheck =
    localStorage.getItem('precheckPending') === 'true' &&
    localStorage.getItem('precheckCompleted') !== 'true';
  if (!canEnterPrecheck) {
    next('/evaluation-hub');
    return;
  }

  next();
});

export default router;
